import { postShares } from '../api/cloudShare';
export default async (shareCreateData, logger) => {
    return postShares(shareCreateData, '/user/{userId}/shares', {}, logger);
};
